import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/Home.vue'
import Supervise from '@/components/content/Supervise.vue'
import Message from '@/components/message/Message.vue'
import My from '@/components/my/My.vue'
import Publish from '@/components/publish/Publish.vue'
import Help from '@/components/publish/Help.vue'
import PublishIdle from '@/components/publish/PublishIdle.vue'
import ToRent from '@/components/publish/ToRent.vue'
import Topic from '@/components/message/Topic.vue'
import Reply from '@/components/message/Reply.vue'
import Unused from '@/components/home/Unused.vue'
import Governance from '@/components/home/Governance.vue'
import InCome from '@/components/home/InCome.vue'
import GoverPay from '@/components/home/GoverPay.vue'
import GoverAll from '@/components/home/GoverAll.vue'
import ViewVoucher from '@/components/home/ViewVoucher.vue'
import LookDetail from '@/components/home/LookDetail.vue'
import RentSale from '@/components/home/RentSale.vue'
import TeamList from '@/components/content/TeamList.vue'
import ChoseCity from '@/components/home/ChoseCity.vue'
import NoticeTab from '@/components/home/NoticeTab.vue'
import VillageNotice from '@/components/home/VillageNotice.vue'
import MeetNotice from '@/components/home/MeetNotice.vue'
import VillageDetail from '@/components/home/VillageDetail.vue'
import RentDetail from '@/components/home/RentDetail.vue'
import ChosePlot from '@/components/home/ChosePlot.vue'
import UnusedDetail from '@/components/home/UnusedDetail.vue'
import EditAdress from '@/components/home/EditAddress.vue'
import SelectAddress from '@/components/home/SelectAddress.vue'
import MyLabel from '@/components/my/MyLabel.vue'
import Opinion from '@/components/my/Opinion.vue'
import AboutUs from '@/components/my/AboutUs.vue'
import SeekHelp from '@/components/home/SeekHelp.vue'
import ResultShow from '@/components/home/ResultShow.vue'
import CanTips from '@/components/home/CanTips.vue'
import SupTips from '@/components/home/SupTips.vue'
import SatTips from '@/components/home/SatTips.vue'
import CanDetail from '@/components/home/CanDetail.vue'
import HelpDetail from '@/components/home/HelpDetail.vue'
import MyIdle from '@/components/my/MyIdle.vue'
import IdleDetail from '@/components/my/IdleDetail.vue'
import Repairs from '@/components/home/Repairs.vue'
import Vote from '@/components/home/Vote.vue'
import MyVillage from '@/components/my/MyVillage.vue'
import MyHouse from '@/components/my/MyHouse.vue'
import HouseConfirm from '@/components/my/HouseConfirm.vue'
import RepairsDetail from '@/components/home/RepairsDetail.vue'
import Voting from '@/components/home/Voting.vue'
import VotingDetail from '@/components/home/VotingDetail.vue'
import videoPage from '@/components/home/videoPage.vue'
import MyVote from '@/components/my/MyVote.vue'
import MyVoteResult from '@/components/my/MyVoteResult.vue'
import MySatisResult from '@/components/my/MySatisResult.vue'
import NewVoteDetail from '@/components/my/NewVoteDetail.vue'
import Result from '@/components/my/Result.vue'
import Repair from '@/components/publish/Repair.vue'
import OpinionDetail from '@/components/my/OpinionDetail.vue'
import HomeAudit from '@/components/my/homeAudit/HomeAduit.vue'
import NotAudit from '@/components/my/homeAudit/NotAudit.vue'
import AlreadAudit from '@/components/my/homeAudit/AlreadAudit.vue'
import RefuseAudit from '@/components/my/homeAudit/RefuseAudit.vue'
import AuditDetail from '@/components/my/AuditDetail.vue'
// import Service from '@/components/content/Service.vue'
import TeamAll from '@/components/content/TeamAll.vue'
import ServiceDetail from '@/components/content/ServiceDetail.vue'
import TeamDetail from '@/components/content/TeamDetail.vue'
import CardCount from '@/components/content/CardCount.vue'
import WeekCardDetail from '@/components/content/WeekCardDetail.vue'
import MonthCardDetail from '@/components/content/MonthCardDetail.vue'
import PrevMonthCardDetail from '@/components/content/PrevMonthCardDetail.vue'
import DayCardDetail from '@/components/content/DayCardDetail.vue'
import PrevQuarterDetail from '@/components/content/PrevQuarterDetail.vue'
import Release from '@/components/content/Release.vue'
import Clocked from '@/components/content/Clocked.vue'
import Looked from '@/components/content/Looked.vue'
import Breaked from '@/components/content/Breaked.vue'
import PrevQuarter from '@/components/content/PrevQuarter.vue'
import HalfYear from '@/components/content/HalfYear.vue'
import Editdata1 from '@/components/my/Editdata1.vue'
import Empower from '@/components/my/Empower.vue'
import Check from '@/components/content/Check.vue'
import CheckPublish from '@/components/content/CheckPublish.vue'
import CheckDetailList from '@/components/content/CheckDetailList.vue'
import CheckDetail from '@/components/content/CheckDetail.vue'
import StartCheck from '@/components/content/StartCheck.vue'
import GoCheckPublish from '@/components/content/GoCheckPublish.vue'
import Ident from '@/components/my/Ident.vue'
import MyCheck from '@/components/my/MyCheck.vue'
import EditCheck from '@/components/my/EditCheck.vue'
import EditCheckEvery from '@/components/my/EditCheckEvery.vue'
import IdentList from '@/components/my/IdentList.vue'
import IdentDetail from '@/components/my/IdentDetail.vue'
import statisticsAll from '@/components/my/statisticsAll'
import Statistics from '@/components/my/Statistics.vue'
import StatisticsD from '@/components/my/StatisticsD.vue'
import StatisticsDetail from '@/components/my/StatisticsDetail.vue'
import StatisticsDDetail from '@/components/my/StatisticsDDetail.vue'
import AlreadyRecycle from '@/components/my/AlreadyRecycle.vue'
import AlreadySendVote from '@/components/my/AlreadySendVote.vue'
import AlreadyVote from '@/components/my/AlreadyVote.vue'
import VisitRecords from '@/components/my/VisitRecords.vue'
import LookVoteDetail from '@/components/my/LookVoteDetail.vue'
import ToExamine from '@/components/content/ToExamine.vue'
import MyRecord from '@/components/content/MyRecord.vue'
import ExamineDetail from '@/components/content/ExamineDetail.vue'
import PunchClock from '@/components/home/PunchClock.vue'
import TakeIn from '@/components/home/TakeIn.vue'
import SatisForm from '@/components/home/SatisForm.vue'
import TakeInDetail from '@/components/home/TakeInDetail.vue'
import TicketRoot from '@/components/home/TicketRoot.vue'
import TakeInResult from '@/components/home/TakeInResult.vue'
import VotingList from '@/components/home/VotingList.vue'
import Login from '@/components/login/Login.vue'
import BlankPage from '@/components/login/BlankPage.vue'
import SignList from '@/components/home/SignList.vue'
import Letter from '@/components/home/Letter.vue'
import CandRegist from '@/components/home/CandRegist.vue'
import PrepareRegist from '@/components/home/PrepareRegist.vue'
import ChangeRegist from '@/components/home/ChangeRegist.vue'
import OtherRegist from '@/components/home/OtherRegist.vue'
import RelectRegist from '@/components/home/RelectRegist.vue'
import SuperRegist from '@/components/home/SuperRegist.vue'
import Scan from '@/components/my/Scan.vue'
import areaSystem from '@/components/my/areaSystem.vue'
import addAreaSystem from '@/components/my/addAreaSystem.vue'
import areaSystemRecord from '@/components/my/areaSystemRecord.vue'
import authAreas from '@/components/my/authAreas.vue'
import NeighborLife from '@/components/home/NeighborLife.vue'
import Entrance from '@/components/my/Entrance.vue'
import Experience from '@/components/my/Experience.vue'
import CheckOffer from '@/components/my/CheckOffer.vue'
import UnderTaking from '@/components/my/UnderTaking.vue'
import AssessMent from '@/components/my/AssessMent.vue'
import costDetail from '@/components/my/costDetail.vue'
import applyRunBuild from '@/components/my/applyRunBuild.vue'
import AddApply from '@/components/my/AddApply.vue'
import ApplyRecord from '@/components/my/ApplyRecord.vue'
import ExamineRun from '@/components/my/runBuild/ExamineRun.vue'
import ToBeReviewed from '@/components/my/runBuild/ToBeReviewed.vue'
import PassedRun from '@/components/my/runBuild/PassedRun.vue'
import NotPassedRun from '@/components/my/runBuild/NotPassedRun.vue'
import WorkTime from '@/components/my/runBuild/WorkTime.vue'
import PunchRecord from '@/components/my/runBuild/PunchRecord.vue'
// 业主大会会议公告（mock）
import MeetingAnnouncementList from '@/components/announcement/MeetingAnnouncementList.vue'
// 业主大会会议公告详情
import MeetingAnnouncementInfo from '@/components/announcement/MeetingAnnouncementInfo.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return {
  //       x: 0,
  //       y: 0
  //     }
  //   }
  // },
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     if (from.meta.keepAlive) {
  //       from.meta.savedPosition = document.body.scrollTop
  //     }
  //     return {
  //       x: 0,
  //       y: to.meta.savedPosition || 0
  //     }
  //   }
  // },
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/BlankPage/:id',
      name: 'BlankPage',
      component: BlankPage
    },
    {
      path: '/Editdata1',
      name: 'Editdata1',
      component: Editdata1
    },
    {
      path: '/Empower/:type',
      name: 'Empower',
      component: Empower
    },
    // 监理部分路由修改(目前只显示了查验)
    {
      path: '/home/Supervise',
      name: 'Supervise',
      component: Supervise,
      redirect: '/TeamList',
      children: [
        {
          path: '/TeamList',
          name: 'TeamList',
          component: TeamList
        },
        // {
        //   path: '/Service',
        //   name: 'Service',
        //   component: Service,
        //   meta: {
        //     keepAlive: true,
        //     isBack: false
        //   }
        // },
        {
          path: '/Check',
          name: 'Check',
          component: Check,
          meta: {
            keepAlive: true,
            isBack: false
          }
        }
      ]
    },
    // {
    //   path: '/Check',
    //   name: 'Check',
    //   component: Check,
    //   meta: {
    //     keepAlive: true,
    //     isBack: false
    //   }
    // },
    {
      path: '/home/NeighborLife',
      name: 'NeighborLife',
      component: NeighborLife,
      redirect: '/SeekHelp',
      children: [
        {
          path: '/SeekHelp',
          name: 'SeekHelp',
          component: SeekHelp,
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/Unused',
          name: 'Unused',
          component: Unused,
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/Repairs',
          name: 'Repairs',
          component: Repairs,
          meta: {
            keepAlive: true,
            isBack: false
          }
        }
      ]
    },
    {
      path: '/home/ResultShow',
      name: 'ResultShow',
      component: ResultShow
    },
    {
      path: '/CanTips/:id',
      name: 'CanTips',
      component: CanTips
    },
    {
      path: '/SupTips/:id',
      name: 'SupTips',
      component: SupTips
    },
    {
      path: '/SatTips/:id',
      name: 'SatTips',
      component: SatTips
    },
    {
      path: '/CanDetail/:id/:uid',
      name: 'CanDetail',
      component: CanDetail
    },
    {
      path: '/message',
      name: 'Message',
      component: Message,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/my',
      name: 'My',
      component: My,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/publish',
      name: 'Publish',
      component: Publish
    },
    {
      path: '/publish/Help',
      name: 'Help',
      component: Help
    },
    {
      path: '/publish/PublishIdle',
      name: 'PublishIdle',
      component: PublishIdle
    },
    {
      path: '/publish/ToRent',
      name: 'ToRent',
      component: ToRent
    },
    {
      path: '/message/Topic',
      name: 'Topic',
      component: Topic
    },
    {
      path: '/message/Reply/:id',
      name: 'Reply',
      component: Reply
    },
    // {
    //   path: '/home/Unused',
    //   name: 'Unused',
    //   component: Unused,
    //   meta: {
    //     keepAlive: true,
    //     isBack: false
    //   }
    // },
    {
      path: '/home/Governance',
      name: 'Governance',
      component: Governance,
      redirect: '/home/InCome',
      children: [
        {
          path: '/home/InCome',
          name: 'InCome',
          component: InCome
        },
        {
          path: '/home/GoverPay',
          name: 'GoverPay',
          component: GoverPay
        },
        {
          path: '/home/GoverAll',
          name: 'GoverAll',
          component: GoverAll
        }
      ]
    },
    {
      path: '/home/RentSale',
      name: 'RentSale',
      component: RentSale,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/home/ChoseCity',
      name: 'ChoseCity',
      component: ChoseCity
    },
    {
      path: '/home/ChosePlot/:id',
      name: 'ChosePlot',
      component: ChosePlot
    },
    {
      path: '/home/NoticeTab',
      name: 'NoticeTab',
      component: NoticeTab,
      redirect: '/VillageNotice',
      children: [
        {
          path: '/VillageNotice',
          name: 'VillageNotice',
          component: VillageNotice
        },
        {
          path: '/MeetNotice',
          name: 'MeetNotice',
          component: MeetNotice
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // }
        }
      ]
    },
    // {
    //   path: '/home/VillageNotice/:id',
    //   name: 'VillageNotice',
    //   component: VillageNotice
    //   // meta: {
    //   //   keepAlive: true,
    //   //   isBack: false
    //   // }
    // },
    {
      path: '/home/VillageDetail/:id/:newold',
      name: 'VillageDetail',
      component: VillageDetail
    },
    {
      path: '/home/RentDetail/:id',
      name: 'RentDetail',
      component: RentDetail
    },
    {
      path: '/home/UnusedDetail/:id',
      name: 'UnusedDetail',
      component: UnusedDetail
    },
    {
      path: '/my/MyLabel',
      name: 'MyLabel',
      component: MyLabel
    },
    {
      path: '/my/Opinion',
      name: 'Opinion',
      component: Opinion
    },
    {
      path: '/my/HomeAudit',
      name: 'HomeAudit',
      component: HomeAudit,
      redirect: '/my/NotAudit',
      children: [
        {
          path: '/my/NotAudit',
          name: 'NotAudit',
          component: NotAudit
        },
        {
          path: '/my/AlreadAudit',
          name: 'AlreadAudit',
          component: AlreadAudit
        },
        {
          path: '/my/RefuseAudit',
          name: 'RefuseAudit',
          component: RefuseAudit
        }
      ]
    },
    {
      path: '/my/AuditDetail/:id',
      name: 'AuditDetail',
      component: AuditDetail
    },
    {
      path: '/home/EditAddress',
      name: 'EditAddress',
      component: EditAdress
    },
    {
      path: '/home/SelectAddress',
      name: 'SelectAddress',
      component: SelectAddress
    },
    {
      path: '/my/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    // {
    //   path: '/home/SeekHelp',
    //   name: 'SeekHelp',
    //   component: SeekHelp,
    //   meta: {
    //     keepAlive: true,
    //     isBack: false
    //   }
    // },
    {
      path: '/home/HelpDetail/:id',
      name: 'HelpDetail',
      component: HelpDetail
    },
    {
      path: '/my/MyIdle',
      name: 'MyIdle',
      component: MyIdle,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/my/IdleDetail/:name/:id',
      name: 'IdleDetail',
      component: IdleDetail
    },
    // {
    //   path: '/home/Repairs',
    //   name: 'Repairs',
    //   component: Repairs,
    //   meta: {
    //     keepAlive: true,
    //     isBack: false
    //   }
    // },
    {
      path: '/home/PunchClock',
      name: 'PunchClock',
      component: PunchClock,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/home/Vote/:id',
      name: 'Vote',
      component: Vote
    },
    {
      path: '/home/TakeIn/:id',
      name: 'TakeIn',
      component: TakeIn
    },
    {
      path: '/home/SatisForm/:id',
      name: 'SatisForm',
      component: SatisForm
    },
    {
      path: '/home/TakeInDetail/:id',
      name: 'TakeInDetail',
      component: TakeInDetail
    },
    {
      path: '/home/TakeInResult/:id',
      name: 'TakeInResult',
      component: TakeInResult
    },
    {
      path: '/home/TicketRoot',
      name: 'TicketRoot',
      component: TicketRoot
    },
    {
      path: '/my/MyVillage/:id',
      name: 'MyVillage',
      component: MyVillage
    },
    {
      path: '/my/MyHouse',
      name: 'MyHouse',
      component: MyHouse
    },
    {
      path: '/my/HouseConfirm',
      name: 'HouseConfirm',
      component: HouseConfirm
    },
    {
      path: '/home/RepairsDetail/:id',
      name: 'RepairsDetail',
      component: RepairsDetail
    },
    {
      path: '/home/VotingList',
      name: 'VotingList',
      component: VotingList
    },
    {
      path: '/home/SignList',
      name: 'SignList',
      component: SignList,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/home/Letter/:type/:id/:title',
      name: 'Letter',
      component: Letter
    },
    {
      path: '/home/CandRegist/:id/:title',
      name: 'CandRegist',
      component: CandRegist
    },
    {
      path: '/home/SuperRegist/:id/:title',
      name: 'SuperRegist',
      component: SuperRegist
    },
    {
      path: '/home/PrepareRegist/:id/:title',
      name: 'PrepareRegist',
      component: PrepareRegist
    },
    {
      path: '/home/ChangeRegist/:id/:title',
      name: 'ChangeRegist',
      component: ChangeRegist
    },
    {
      path: '/home/OtherRegist/:id/:title',
      name: 'OtherRegist',
      component: OtherRegist
    },
    {
      path: '/home/RelectRegist/:id/:title',
      name: 'RelectRegist',
      component: RelectRegist
    },
    // {
    //   path: '/home/Voting',
    //   name: 'Voting',
    //   component: Voting,
    //   meta: {
    //     keepAlive: true,
    //     isBack: false
    //   }
    // },
    {
      path: '/home/Voting/:id/:type',
      name: 'Voting',
      component: Voting
      // meta: {
      //   keepAlive: true,
      //   isBack: false
      // }
    },
    {
      path: '/home/VotingDetail/:id/:type/:newold',
      name: 'VotingDetail',
      component: VotingDetail
    },
    {
      path: '/home/videoPage',
      name: 'videoPage',
      component: videoPage
    },
    {
      path: '/my/MyVote',
      name: 'MyVote',
      component: MyVote,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      // path: '/my/MyVoteResult/:type/:id/:style',
      path: '/my/MyVoteResult',
      name: 'MyVoteResult',
      component: MyVoteResult
    },
    {
      path: '/my/MySatisResult/:type/:id',
      name: 'MySatisResult',
      component: MySatisResult
    },
    {
      path: '/my/NewVoteDetail',
      name: 'NewVoteDetail',
      component: NewVoteDetail
    },
    {
      path: '/my/Result/:id/:status',
      name: 'Result',
      component: Result
    },
    {
      path: '/publish/Repair',
      name: 'Repair',
      component: Repair
    },
    {
      path: '/my/OpinionDetail/:id',
      name: 'OpinionDetail',
      component: OpinionDetail
    },
    {
      path: '/TeamAll/:id',
      name: 'TeamAll',
      component: TeamAll
    },
    {
      path: '/ServiceDetail/:id',
      name: 'ServiceDetail',
      component: ServiceDetail
    },
    {
      path: '/TeamDetail/:id',
      name: 'TeamDetail',
      component: TeamDetail
    },
    {
      path: '/CardCount/:id',
      name: 'CardCount',
      component: CardCount
    },
    {
      path: '/WeekCardDetail/:id',
      name: 'WeekCardDetail',
      component: WeekCardDetail
    },
    {
      path: '/Release',
      name: 'Release',
      component: Release
    },
    {
      path: '/Clocked',
      name: 'Clocked',
      component: Clocked
    },
    {
      path: '/Looked',
      name: 'Looked',
      component: Looked,
      redirect: '/ToExamine',
      children: [
        {
          path: '/ToExamine',
          name: 'ToExamine',
          component: ToExamine
        },
        {
          path: '/MyRecord',
          name: 'MyRecord',
          component: MyRecord
        }
      ]
    },
    {
      path: '/Breaked',
      name: 'Breaked',
      component: Breaked
    },
    {
      path: '/MonthCardDetail/:id',
      name: 'MonthCardDetail',
      component: MonthCardDetail
    },
    {
      path: '/PrevMonthCardDetail/:id',
      name: 'PrevMonthCardDetail',
      component: PrevMonthCardDetail
    },
    {
      path: '/PrevQuarter/:id',
      name: 'PrevQuarter',
      component: PrevQuarter
    },
    {
      path: '/HalfYear/:id',
      name: 'HalfYear',
      component: HalfYear
    },
    {
      path: '/DayCardDetail/:id',
      name: 'DayCardDetail',
      component: DayCardDetail
    },
    {
      path: '/PrevQuarterDetail/:year/:month/:id',
      name: 'PrevQuarterDetail',
      component: PrevQuarterDetail
    },
    {
      path: '/CheckPublish',
      name: 'CheckPublish',
      component: CheckPublish
    },
    {
      path: '/CheckDetailList/:id',
      name: 'CheckDetailList',
      component: CheckDetailList
    },
    {
      path: '/CheckDetail/:id',
      name: 'CheckDetail',
      component: CheckDetail
    },
    // {
    //   path: '/CheckDetail/:id/:upid',
    //   name: 'CheckDetail',
    //   component: CheckDetail
    // },
    {
      path: '/StartCheck/:id/:liftNum',
      name: 'StartCheck',
      component: StartCheck
      // meta: {
      //   keepAlive: true,
      //   isBack: false
      // }
    },
    {
      path: '/my/Ident',
      name: 'Ident',
      component: Ident
    },
    {
      path: '/GoCheckPublish/:id/:name/:relatedId/:liftNum/:hid/:mainid',
      name: 'GoCheckPublish',
      component: GoCheckPublish
    },
    {
      path: '/home/ViewVoucher/:id',
      name: 'ViewVoucher',
      component: ViewVoucher
    },
    {
      path: '/home/LookDetail/:type',
      name: 'LookDetail',
      component: LookDetail
    },
    {
      path: '/my/MyCheck',
      name: 'MyCheck',
      component: MyCheck,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/my/EditCheck/:id/:categoryid',
      name: 'EditCheck',
      component: EditCheck
    },
    {
      path: '/my/EditCheckEvery/:id/:categoryid/:name/:liftNum',
      name: 'EditCheckEvery',
      component: EditCheckEvery
    },
    {
      path: '/my/IdentList',
      name: 'IdentList',
      component: IdentList
    },
    {
      path: '/my/IdentDetail/:id',
      name: 'IdentDetail',
      component: IdentDetail
    },
    {
      path: '/my/statisticsAll',
      name: 'statisticsAll',
      component: statisticsAll,
      redirect: '/my/Statistics',
      children: [
        {
          path: '/my/Statistics',
          name: 'Statistics',
          component: Statistics,
          meta: {
            keepAlive: true,
            isBack: false
          }
        },
        {
          path: '/my/StatisticsD',
          name: 'StatisticsD',
          component: StatisticsD,
          meta: {
            keepAlive: true,
            isBack: false
          }
        }
      ]
    },
    {
      path: '/my/StatisticsDetail/:aid/:vid/:page/:stype/:did/:yid/:newold',
      name: 'StatisticsDetail',
      component: StatisticsDetail
    },
    {
      path: '/my/StatisticsDDetail/:aid/:vid/:page/:newold',
      name: 'StatisticsDDetail',
      component: StatisticsDDetail
    },
    {
      path: '/my/AlreadyVote/:aid/:vid/:name/:page/:newold',
      name: 'AlreadyVote',
      component: AlreadyVote
    },
    {
      path: '/my/AlreadySendVote/:aid/:vid/:name/:page/:newold',
      name: 'AlreadySendVote',
      component: AlreadySendVote
    },
    {
      path: '/my/AlreadyRecycle/:aid/:vid/:name/:page/:newold',
      name: 'AlreadyRecycle',
      component: AlreadyRecycle
    },
    {
      path: '/my/LookVoteDetail/:did/:vid/:page/:newold',
      name: 'LookVoteDetail',
      component: LookVoteDetail
    },
    {
      path: '/my/VisitRecords/:houseid/:vid/:newold',
      name: 'VisitRecords',
      component: VisitRecords
    },
    {
      path: '/ExamineDetail/:id',
      name: 'ExamineDetail',
      component: ExamineDetail
    },
    {
      path: '/my/Scan',
      name: 'Scan',
      component: Scan
    },
    {
      path: '/my/areaSystem',
      name: 'areaSystem',
      component: areaSystem,
      redirect: '/addAreaSystem',
      children: [
        {
          path: '/addAreaSystem',
          name: 'addAreaSystem',
          component: addAreaSystem
        },
        {
          path: '/areaSystemRecord',
          name: 'areaSystemRecord',
          component: areaSystemRecord
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // }
        }
      ]
    },
    {
      path: '/my/authAreas',
      name: 'authAreas',
      component: authAreas
    },
    {
      path: '/my/Entrance',
      name: 'Entrance',
      component: Entrance
    },
    {
      path: '/my/Experience',
      name: 'Experience',
      component: Experience
    },
    {
      path: '/my/CheckOffer',
      name: 'CheckOffer',
      component: CheckOffer,
      redirect: '/UnderTaking',
      children: [
        {
          path: '/UnderTaking',
          name: 'UnderTaking',
          component: UnderTaking,
          meta: {
            keepAlive: true, // 页面需要缓存
            isBack: false // 用于判断上一个页面
          }
        },
        {
          path: '/AssessMent',
          name: 'AssessMent',
          component: AssessMent,
          meta: {
            keepAlive: true,
            isBack: false
          }
        }
      ]
    },
    {
      path: '/my/costDetail',
      name: 'costDetail',
      component: costDetail
    },
    {
      path: '/my/applyRunBuild',
      name: 'applyRunBuild',
      component: applyRunBuild,
      redirect: '/AddApply',
      children: [
        {
          path: '/AddApply',
          name: 'AddApply',
          component: AddApply
        },
        {
          path: '/ApplyRecord',
          name: 'ApplyRecord',
          component: ApplyRecord
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // }
        }
      ]
    },
    {
      path: '/my/ExamineRun',
      name: 'ExamineRun',
      component: ExamineRun,
      redirect: '/my/ToBeReviewed',
      children: [
        {
          path: '/my/ToBeReviewed',
          name: 'ToBeReviewed',
          component: ToBeReviewed
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // }
        },
        {
          path: '/my/PassedRun',
          name: 'PassedRun',
          component: PassedRun
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // }
        },
        {
          path: '/my/NotPassedRun',
          name: 'NotPassedRun',
          component: NotPassedRun
          // meta: {
          //   keepAlive: true,
          //   isBack: false
          // }
        }
      ]
    },
    {
      path: '/my/WorkTime',
      name: 'WorkTime',
      component: WorkTime
    },
    {
      path: '/my/PunchRecord/:id',
      name: 'PunchRecord',
      component: PunchRecord
    },
    {
      // 业主大会会议公告：外链带公告分组码 code（?code=xx 或路径 /home/MeetingAnnouncement/xx）
      path: '/home/MeetingAnnouncement/:code?',
      name: 'MeetingAnnouncement',
      component: MeetingAnnouncementList
    },
    {
      // 业主大会会议公告详情：分组码 code + 公告 id
      path: '/home/MeetingAnnouncementInfo/:code/:id',
      name: 'MeetingAnnouncementInfo',
      component: MeetingAnnouncementInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js